import {handleActions} from 'redux-actions';
import {checkForNullAndFormat} from 'QCWorkflow/QCManager/Redux/QCManagerReducer';
import {SET_CONTENT_PARTNERS} from './ContentPartnersAction';
import {
    ContentPartnerState,
    ContentPartnerPayload,
    ContentPartnersResponse,
} from '../ContentPartnersTypes';
import {
    CONTENT_PARTNER_RESET_INITIAL_VALUES_FOR_EDITING,
    CONTENT_PARTNER_GET_INITIAL_VALUES_FOR_EDITING,
} from '../EditingContentPartner/Redux/EditingContentPartnerAction';

export const formatRow = (row: ContentPartnersResponse) => {
    const {createdAt, updatedAt, deletedAt, ...rest} = row;
    return {
        createdAt: checkForNullAndFormat(createdAt),
        updatedAt: checkForNullAndFormat(updatedAt),
        deletedAt: checkForNullAndFormat(deletedAt),
        ...rest,
    };
};

export const setContentPartners = (
    state: ContentPartnerState,
    {payload}: ContentPartnerPayload
): ContentPartnerState => {
    const {rows, total} = payload;

    if (rows)
        return {
            ...state,
            rows: rows.map(formatRow),
            total,
        };

    return state;
};

export const initialEditState = {
    id: 0,
    partnerName: '',
    cmsPartnerId: '',
    active: true,
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
};

export const initialState = {
    rows: [],
    total: 0,
    ...initialEditState,
};

export const setInitialValuesForEditing = (
    state: ContentPartnerState,
    {payload}: ContentPartnerPayload
) => {
    if (payload) {
        const {
            active,
            createdAt,
            updatedAt,
            deletedAt,
            cmsPartnerId,
            partnerName,
        } = payload;

        return {
            ...state,
            cmsPartnerId,
            partnerName,
            active,
            createdAt: checkForNullAndFormat(createdAt),
            updatedAt: checkForNullAndFormat(updatedAt),
            deletedAt: checkForNullAndFormat(deletedAt),
        };
    }
    return state;
};

export const resetInitialValuesForEditing = (state: ContentPartnerState) => {
    return {
        ...state,
        ...initialState,
    };
};

const handlers = {
    [SET_CONTENT_PARTNERS]: setContentPartners,
    [CONTENT_PARTNER_GET_INITIAL_VALUES_FOR_EDITING]: setInitialValuesForEditing,
    [CONTENT_PARTNER_RESET_INITIAL_VALUES_FOR_EDITING]: resetInitialValuesForEditing,
};

export default handleActions(handlers, initialState);
